<template>
    <div class="ModalTeste">
        <b-modal ref="modal-teste" id="modalTeste" size="lg" body-class="m-modal-body" :hide-footer="true" :hide-header="true" content-class="wrapper top-flashlight leftside light-xl" modal-class="rbt-modal-box share-modal" centered>
            <h5 class="title">Teste da IA.</h5>
            
            <button class="close-button" data-bs-dismiss="modal" @click="close">
                <i class="feather-x"></i>
            </button>
            <div class="border-form">
                <form id="formNormativa">
                    <div class="mb-3">
                        <h6 for="prompt" class="form-label">Prompt</h6>
                        <textarea style="border: 1px solid black;" type="text" id="prompt" name="prompt" v-model="prompt" rows="5" required></textarea>
                    </div>
                    <div class="mb-3">
                        <h6 for="" class="form-label">Arquivo</h6>
                        <label for="myfile" class="custom-file-upload ">Selecionar Arquivos</label>
                        <input type="file" id="myfile" name="myfile"  @change="onFileChange">

                        <div class="box-files mt-3" v-if="files">
                            <div class="item-files me-2" v-for="(file, index) in files" :key="index">
                                <span class="me-3">{{file.name}}</span>
                                <button class="react-btn btn-default btn-small btn-border btn-selecionar px-2" @click="removeFile(index)"><i data-v-61dd7a3d="" class="feather-x"></i></button>
                            </div>
                        </div>
                    </div>
                    <div class="text-end">
                        <button type="button" class="btn btn-warning me-2" @click="clear"><i class="feather-refresh-ccw"></i></button>
                        <button type="button" class="btn btn-primary" @click="enviar">Enviar</button>
                    </div>
                    
                </form>
                <template v-if="flResposta">
                    <h6>Resposta:</h6>
                    <div class="" v-html="resposta">
                        
                    </div>
                </template>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalTeste',
        data: function () {
            return {

                prompt: "",
                files: [],
                resposta: "",
                flResposta: false,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {},
        methods: {
            enviar() {
                let $this = this;
                const formData = new FormData();
                for (let i = 0; i < this.files.length; i++) {
                    formData.append("files", $this.files[0]);
                }
                formData.append("token", "82cf1e0b2c13dcdda5ddb17f08c0d51f");
                formData.append("prompt", $this.prompt);


                axios.post(`${urlApi}/Utilidade/GetResposta`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, } })
                    .then(res => {
                        if (res.data.status == "success") {
                            $this.flResposta = true;
                            $this.resposta = res.data.resposta;
                        } else {
                            avisoErro("Não foi possível enviar a solicitação.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    });
                return false;                
            },

            clear() {
                this.prompt = "";
                this.files = [];
                this.resposta = "";
                this.flResposta = false;
            },
                        
            close() {
                this.$refs['modal-teste'].hide();
            },

            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createFile(files);
            },

            createFile(files) {
                for (var index = 0; index < files.length; index++) {
                    this.files.push(files[index]);
                }
            },

            removeFile(index) {
                this.files.splice(index, 1)
            },

            
            download(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            }

        },
        created: function () {
            this.clear();
        },
        watch: {
            showModal: function () {
                this.$refs['modal-teste'].show();
                this.clear();
            },

        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    /* MODAL ModalNormativa */
    .form-control {
        border: 1px solid #474747;
    }

    input[type="file"] {
        display: none;
    }

    .custom-file-upload {
        display: inline-block;
        padding: 6px 25px;
        cursor: pointer;
        background: linear-gradient(90deg, rgba(0, 81, 173, 1) 0%, rgba(0, 191, 81, 1) 100%);
        font-weight: 500;
        font-size: 16px;
        line-height: 26px;
        color: #FFF;
    }

    .box-files {
        display: flex;
        .item-files{
            display: inline-block;
            padding: 5px;
            border: 1px solid #ccc;
            border-radius: 5px;
        }
    }

    .border-form {
        border: 1px solid #dedede;
        border-radius: 5px;
        padding: 10px 20px;
    }

</style>

<style lang="css">
    #modalTeste___BV_modal_content_ {
        padding: 45px !important;
    }
</style>